$('.js-form-modal-watchdog').validate({
    submitHandler: function (form) {
        Form.ajaxPost(form, function (data) {
            $('.js-watchdog-error').hide();
            $('.js-watchdog-success').hide();

            if (!data.status) {
                $('.js-watchdog-error')
                    .text(data.message)
                    .slideDown(250);
            } else {
                $('.js-watchdog-success')
                    .text(data.message)
                    .slideDown(250);
            }
        }, 'json');
    }
});